export default "__VITE_ASSET__96ee6e63__"